import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { contextService } from '../services/api';

interface AppContextType {
  menus: any[];
  favoritos: number[];
  permissoes: string[];
  loading: boolean;
  refetch: () => Promise<void>;
}

const AppContext = createContext<AppContextType | undefined>(undefined);

export const ContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, municipioAtivo } = useAuth();
  const [menus, setMenus] = useState<any[]>([]);
  const [favoritos, setFavoritos] = useState<number[]>([]);
  const [permissoes, setPermissoes] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  const fetchContext = async () => {
    if (!isAuthenticated) return;

    setLoading(true);
    try {
      const data = await contextService.getContext(municipioAtivo?.id);
      setMenus(data.menus || []);
      setFavoritos(data.favoritos || []);
      setPermissoes(data.permissoes || []);
    } catch (error) {
      console.error('Erro ao carregar contexto:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContext();
  }, [isAuthenticated, municipioAtivo?.id]);

  return (
    <AppContext.Provider
      value={{
        menus,
        favoritos,
        permissoes,
        loading,
        refetch: fetchContext,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext deve ser usado dentro de um ContextProvider');
  }
  return context;
};
